// extracted by mini-css-extract-plugin
export default {"miniQuizSearchResultCard":"miniQuizSearchResultCard__NzJkY","noBorder":"noBorder__OGMxO","hed":"hed__NzY3M","dek":"dek__M2UyN"};